import { CollectedExtraction } from "./types";
import { ContinuousCoverage } from "./assessContinuous";
import {
    coverageMatchedRow,
    coverageRequirementAwaitingRow,
    coverageUnmatchedDoc,
} from "./coverageRows";

function byDocumentId(a: CollectedExtraction, b: CollectedExtraction): number {
    return a.documentId - b.documentId;
}

export function assessSingleton(
    key: string,
    docs: CollectedExtraction[],
): ContinuousCoverage {
    if (docs.length === 0) {
        return {
            rows: [coverageRequirementAwaitingRow(key, null)],
            unmatched: [],
            isCovered: false,
        };
    }
    const [first, ...rest] = [...docs].sort(byDocumentId);
    return {
        rows: [coverageMatchedRow({ key, doc: first, period: null })],
        unmatched: rest.map((doc) => coverageUnmatchedDoc(doc, "duplicate")),
        isCovered: true,
    };
}
